export default __webpack_public_path__ + "static/media/hannakatieli.f6b612a3.webp";